import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import FocusTrap from './focus-trap';

const Panel = ({
  children,
  alignment = 'right',
  context = null,
  triggers,
  defaultOpen = false,
  additionalClasses = '',
  overlay = false,
  disableBodyScroll = false
}) => {
  const { openTriggerEl, closeTriggerEl, toggleEl } = triggers;
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [isBodyScroll, setBodyScroll] = useState(false);
  const handleOpenEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(true);
    if(disableBodyScroll){
      setBodyScroll(true);
    }
  };
  const handleCloseEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(false);
    if(disableBodyScroll){
      setBodyScroll(false);
    }
  };
  const handleToggleEvent = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (openTriggerEl) openTriggerEl.addEventListener('click', handleOpenEvent);
    if (closeTriggerEl)
      closeTriggerEl.addEventListener('click', handleCloseEvent);
    if (toggleEl) toggleEl.addEventListener('click', handleToggleEvent);
    if (context) {
      document.addEventListener(`${context}:open`, handleOpenEvent);
      document.addEventListener(`${context}:close`, handleCloseEvent);
    }

    return () => {
      if (openTriggerEl)
        openTriggerEl.removeEventListener('click', handleOpenEvent);
      if (closeTriggerEl)
        closeTriggerEl.removeEventListener('click', handleCloseEvent);
      if (toggleEl) toggleEl.removeEventListener('click', handleToggleEvent);
      if (context) {
        document.removeEventListener(`${context}:open`, handleOpenEvent);
        document.removeEventListener(`${context}:close`, handleCloseEvent);
      }
    };
  }, [openTriggerEl, closeTriggerEl, toggleEl]);

  let focusTrap = null;

  useEffect(() => {
    if (isOpen) {
      focusTrap = new FocusTrap(document.querySelector('[data-panel-focus-trap]'));
      focusTrap.init();
    };

    return () => {
      if (focusTrap) focusTrap.destroy();
    };
  }, [isOpen, focusTrap]);

  useEffect(() => {
    const body = document.querySelector('body');
    if(isBodyScroll){
      body.classList.add('overflow-hidden' , 'relative')
    } else {
      body.classList.remove('overflow-hidden', 'relative')
    }
  }, [isBodyScroll]);

  const closedClass =
    alignment === 'right' ? 'translate-x-full' : '-translate-x-full';

  return (
    <>
      {overlay === true && isOpen && (
        <div onClick={handleCloseEvent} className="block w-full h-full fixed inset-0 z-30 bg-primary opacity-50"></div>
      )}
      <div
        className={`
        block
        max-w-panel
        w-full h-full
        fixed
        top-0
        bottom-0
        transition-transform
        z-[9999999999999]
        bg-white
        ${alignment === 'right' ? 'right-0' : 'left-0'} ${
          isOpen ? 'translate-x-0' : closedClass
        } ${additionalClasses}`}
      >
        {children}
      </div>
    </>
  );
};

export default Panel;
